import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://divaisetech.com';
const DEFAULT_IMAGE = `${SITE_URL}/divaisetech-logo.png`;

// Accepts title, description, keywords, canonical, type, image, schema, noindex
export default function SEO({
  title,
  description,
  keywords,
  canonical,
  type = 'website',
  image = DEFAULT_IMAGE,
  schema,
  noindex = false,
}) {
  const robots = noindex ? 'noindex, nofollow' : 'index, follow';

  const schemaNodes = Array.isArray(schema)
    ? schema
    : schema
      ? [schema]
      : [];

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}

      <meta name="robots" content={robots} />

      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content="Divaise Technology" />
      {image && <meta property="og:image" content={image} />}

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}

      {schemaNodes.map((node, idx) => (
        <script key={`schema-${idx}`} type="application/ld+json">
          {JSON.stringify(node)}
        </script>
      ))}
    </Helmet>
  );
}
